import { render } from "./EnvelopeForm.vue?vue&type=template&id=1133e720"
import script from "./EnvelopeForm.vue?vue&type=script&lang=js"
export * from "./EnvelopeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__